import React, { Component } from "react";
import {
  SubHeaderWithControl,
  SubHeaderWithControlButton,
  SubHeaderWithControlLine,
  SubHeaderWithControlText,
} from "./styles";

class TitleWithControl extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.width != undefined && this.props.width != null) {
      var css = { width: this.props.width };
    } else {
      var css = {};
    }
    return (
      <SubHeaderWithControl>
        <SubHeaderWithControlText style={css}>
          {this.props.children != undefined ? (
            this.props.children
          ) : (
            <p>
              Após concluir todos os passos, seu{" "}
              <strong>
                pedido deverá ser encaminhado ao cliente para aprovação final
              </strong>
            </p>
          )}
        </SubHeaderWithControlText>
        <SubHeaderWithControlLine></SubHeaderWithControlLine>
        {this.props.back != null ? (
          <SubHeaderWithControlButton onClick={this.props.back}>
            <span className="icon icon-25 icon-arrow-return-orange"></span>
            <p>Voltar</p>
          </SubHeaderWithControlButton>
        ) : (
          <></>
        )}
      </SubHeaderWithControl>
    );
  }
}
export default TitleWithControl;
